import { ReactElement } from 'react';
import { Button, Card, CardContent } from '@mui/material';
import { LoadingFragment, LambdaFunctionScalingConfigDetails, PageTitle } from '@localstack/ui';
import { useRoutes, useAwsGetter } from '@localstack/services';

import { useParams } from 'react-router-dom';

import { LambdaProps } from './types';
import { ScalingConfigAlert } from './components/ScalingConfigAlert';

export const LambdaFunctionScalingConfig = ({ Layout, clientOverrides, routes }: LambdaProps): ReactElement => {
  const { goto } = useRoutes();

  const { name: functionNameWithVersion } = useParams<'name'>();
  const [functionNameWithoutVersion, functionVersion] = functionNameWithVersion?.split(':') ?? [];

  const isPublishedVersion = !!functionVersion && functionVersion !== '$LATEST';

  const { data, isLoading: isFunctionScalingConfigLoading } = useAwsGetter(
    'Lambda',
    'getFunctionScalingConfig',
    [{ FunctionName: functionNameWithoutVersion, Qualifier: functionVersion }],
    { clientOverrides, enable: isPublishedVersion },
  );

  return (
    <>
      <Layout
        title={
          <PageTitle
            title="Event Function Scaling Config"
            breadcrumbs={[
              ['Lambda', () => goto(routes.RESOURCES_LAMBDA)],
              [
                functionNameWithVersion,
                () => goto(routes.RESOURCES_LAMBDA_FUNCTION, { name: functionNameWithVersion }),
              ],
              ['Scaling Config ', null],
            ]}
          />
        }
        documentTitle="Lambda: Event Function Scaling Config"
        actions={
          <>
            <Button
              variant="outlined"
              onClick={() =>
                goto(routes.RESOURCES_LAMBDA_FUNCTION_SCALING_CONFIG_UPDATE, { name: functionNameWithVersion })
              }
            >
              Update
            </Button>
          </>
        }
      >
        {!isPublishedVersion && <ScalingConfigAlert />}
        {isPublishedVersion && (
          <Card>
            <CardContent>
              <LoadingFragment loading={isFunctionScalingConfigLoading} variant="list" height={50} size={10}>
                <LambdaFunctionScalingConfigDetails data={data} />
              </LoadingFragment>
            </CardContent>
          </Card>
        )}
      </Layout>
    </>
  );
};
